var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "charts" }, [
    _c(
      "div",
      {
        staticClass:
          "navBar-filter grid__cell-md-4 grid grid--jc-between grid--ai-middle"
      },
      [
        _c(
          "p",
          { staticClass: "headline-large white mg mg--l-3 grid__cell-md-2" },
          [_vm._v(_vm._s(_vm.$t("charts.titleView")))]
        ),
        _c("svgicon", {
          staticClass: "grid__cell-md-2 mg mg--r-3 refresh-button",
          attrs: { icon: "refresh", height: "30", width: "30", color: "white" },
          on: { click: _vm.handleGetDataCharts }
        }),
        _c(
          "div",
          { staticClass: "container-filters mg mg--t-2" },
          [
            _c("ma-data-filter", {
              key: _vm.keyFilter,
              staticClass: "filters mg mg--l-3",
              attrs: {
                dataArrFilters: _vm.dataFilters,
                showHintToDate: _vm.hintSelectToDate,
                showHintFromDate: _vm.hintSelectFromDate,
                selectedOption: _vm.selectedOptionFilter
              },
              on: {
                "filterCompany:change": _vm.handleFilterCompany,
                "filterWarranty:change": _vm.handleFilterWarranty,
                "filterSubWarranty:change": _vm.handleFilterSubWarranty,
                "fromDate:change": _vm.handleDateFromFilterChange,
                "toDate:change": _vm.handleDateToFilterChange
              }
            }),
            _c(
              "button",
              {
                staticClass: "mainYellow mg mg--r-3",
                on: { click: _vm.handleClickDownloadData }
              },
              [_c("p", [_vm._v(_vm._s(_vm.$t("charts.downloadData")))])]
            ),
            _c(
              "ma-modal",
              {
                ref: "downloadModal",
                staticClass: "modal-download",
                attrs: { type: "small" }
              },
              [
                _c("template", { slot: "modalContent" }, [
                  _c("div", { staticClass: "modal__main" }, [
                    _c("div", { staticClass: "container-content_modal" }, [
                      _c(
                        "p",
                        { staticClass: "black headline-large mg mg--b-4" },
                        [_vm._v(_vm._s(_vm.$t("downloadModal.title")))]
                      ),
                      _c("p", { staticClass: "text-medium mg mg--b-3" }, [
                        _vm._v(_vm._s(_vm.$t("downloadModal.text")))
                      ])
                    ])
                  ])
                ])
              ],
              2
            )
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "grid" }, [
      _c("div", { staticClass: "grid__cell-md-1" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("div", { staticClass: "label mg mg--b-1" }, [
              _c("p", { staticClass: "headline-medium-regular" }, [
                _vm._v(_vm._s(_vm.$t("charts.mapTitle")))
              ]),
              _c("p", { staticClass: "text-small mg mg--t-1" }, [
                _vm._v(_vm._s(_vm.zipCodeDisplay))
              ])
            ]),
            _vm.dataAllPostCodes.length > 0
              ? _c("ma-map-post-codes", {
                  attrs: { totalSinistersByPostCodes: _vm.dataAllPostCodes },
                  on: { "marker:click": _vm.handleMarkerClick }
                })
              : _c(
                  "p",
                  { staticClass: "grid grid--ai-middle grid--jc-middle" },
                  [_vm._v(_vm._s(_vm.$t("charts.noDataAvailable")))]
                )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "grid__cell-md-3" }, [
        _c(
          "div",
          { staticClass: "container fst-graph" },
          [
            _c("p", { staticClass: "headline-medium-regular mg mg--b-3" }, [
              _vm._v(_vm._s(_vm.$t("charts.sinisterEvolutionTitle")))
            ]),
            _vm.dataAllCharts.sinister_evolution_chart.length > 0
              ? _c("ma-chart-bar-average", {
                  key: _vm.keyEvolutionBar,
                  attrs: {
                    dataBarChart: _vm.dataAllCharts.sinister_evolution_chart,
                    chartType: "bar",
                    options: "{responsive: true, maintainAspectRatio: false}"
                  }
                })
              : _c(
                  "p",
                  { staticClass: "grid grid--ai-middle grid--jc-middle" },
                  [_vm._v(_vm._s(_vm.$t("charts.noDataAvailable")))]
                )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass:
            "container-small_charts grid__cell-md-4 grid grid--ai-middle grid--jc-around"
        },
        [
          _c("div", { staticClass: "grid__cell-md-2 chart-bar" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.dataAllCharts.damage_subtype_chart.length > 0
                  ? _c("ma-chart-bar", {
                      key: _vm.keyBarChart,
                      attrs: {
                        titleBarChart: _vm.$t("charts.barChartDamageSubType"),
                        isTitledisplayed: "",
                        dataBarChart: _vm.dataAllCharts.damage_subtype_chart,
                        chartType: "horizontalBar"
                      }
                    })
                  : _c(
                      "p",
                      { staticClass: "grid grid--ai-middle grid--jc-middle" },
                      [_vm._v(_vm._s(_vm.$t("charts.noDataAvailable")))]
                    )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "grid__cell-md-2 chart-bar" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.dataAllCharts.damage_type_chart.length > 0
                  ? _c("ma-chart-bar", {
                      key: _vm.keyBarChart,
                      attrs: {
                        titleBarChart: _vm.$t("charts.barChartDamageType"),
                        isTitledisplayed: "",
                        dataBarChart: _vm.dataAllCharts.damage_type_chart,
                        chartType: "horizontalBar"
                      }
                    })
                  : _c(
                      "p",
                      { staticClass: "grid grid--ai-middle grid--jc-middle" },
                      [_vm._v(_vm._s(_vm.$t("charts.noDataAvailable")))]
                    )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "container-small_charts grid__cell-md-4 grid grid--ai-middle grid--jc-around"
        },
        [
          _c("div", { staticClass: "grid__cell-md-2 chart-bar" }, [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.dataAllCharts.reparation_cost_evolution_chart.length > 0
                  ? _c("ma-chart-bar", {
                      key: _vm.keyBarChart,
                      attrs: {
                        titleBarChart: _vm.$t(
                          "charts.barChartCompensationType"
                        ),
                        isTitledisplayed: "",
                        dataBarChart:
                          _vm.dataAllCharts.reparation_cost_evolution_chart,
                        chartType: "horizontalBar"
                      }
                    })
                  : _c(
                      "p",
                      { staticClass: "grid grid--ai-middle grid--jc-middle" },
                      [_vm._v(_vm._s(_vm.$t("charts.noDataAvailable")))]
                    )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "grid__cell-md-2 chart-pie" }, [
            _vm.dataAllCharts.damage_subtype_distribution_chart.length > 0
              ? _c(
                  "div",
                  { staticClass: "container grid" },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "headline-medium-regular mg mg--b-5 mg--l-6"
                      },
                      [_vm._v(_vm._s(_vm.$t("charts.pieChart")) + "  ")]
                    ),
                    _c("ma-chart-pie", {
                      attrs: {
                        dataBarChart:
                          _vm.dataAllCharts.damage_subtype_distribution_chart
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "p",
                  { staticClass: "grid grid--ai-middle grid--jc-middle" },
                  [_vm._v(_vm._s(_vm.$t("charts.noDataAvailable")))]
                )
          ])
        ]
      ),
      _c("div", { staticClass: "grid__cell-md-4" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("p", { staticClass: "headline-medium mg mg--b-3" }, [
              _vm._v(_vm._s(_vm.$t("charts.tableTitle")))
            ]),
            _c("p", { staticClass: "text-medium mg mg--b-3" }, [
              _vm._v(_vm._s(_vm.tableText))
            ]),
            _c("ma-chart-table", {
              key: _vm.keyTable,
              attrs: { dataTableChart: _vm.dataTable }
            }),
            _c("ma-paginator", {
              staticClass: "mg mg--t-6",
              attrs: {
                current: _vm.currentPage,
                total: _vm.totalPages,
                handleClickDecreasePage: _vm.handleClickPreviousPage,
                handleClickIncreasePage: _vm.handleClickNextPage
              },
              on: { "page:set": _vm.handlePageSet }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }